module.exports = __webpack_public_path__ + "img/sunich.4da8d4f.png";